export enum COOL_OFF_TRADE_STATUSES {
	UNINITIALIZED = "uninitialized",
	ACTIVE = "active",
	BLOCKED = "blocked",
	COOLING_OFF = "cooling_off",
	PENDING_CHECK = "pending_check"
}

export enum QUESTIONNAIRE_STATUSES {
	PENDING = "pending"
}

export enum COOL_OFF_CTA_ACTION {
	LINK = "link",
	CONFIRM = "confirm",
	CANCEL = "cancel"
}

export interface CoolOffWidgetModel {
	status: string;
	client_categorization_status: string;
	appropriateness_test_status: string;
	start_time?: string;
	end_time?: string | null;
	remaining_time?: number | null;
	title_prompt: string | null;
	message_prompt?: string | null;
	title: string | null;
	messages: string[] | null;
	cta?:
		| {
				action: string;
				link?: string;
				text: string;
		  }[]
		| null;
}
